import { Fragment, useCallback, useEffect, useState } from "react";
import { Container, Row, Col, Card } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import CreateServiceModal from "./components/createServiceModal";
import {
  getAllServices,
  setService,
} from "../../../store/slices/servicesSlice";
import CreateSubServiceModal from "./components/createSubServicesModal";
import CreateFormModal from "./components/createFormModal";
import { useDebounce } from "../../../Hooks/useDebounce";

const ServicesTable = () => {
  const history = useNavigate();
  const dispatch = useDispatch();
  const client = useSelector((state) => state.clients?.selectedClient?.value);
  const [data, setData] = useState([]);
  const [totalCount, setCount] = useState(0);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isSubServiceModalOpen, setSubServiceModalOpen] = useState(false);
  const [isCreateFormModalOpen, setCreateFormModalModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const debouncedSearch = useDebounce(searchQuery, 300);
  const [sorting, setSorting] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);
  const columnFilterSearch = useDebounce(columnFilters, 300);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const columns = useMemo(
    () => [
      {
        accessorKey: "ID",
        header: "Service ID",
        size: 150,
      },
      {
        accessorKey: "name",
        header: "Service Name",
        size: 150,
      },
      {
        accessorKey: "type",
        header: "Benefit Type",
        size: 150,
      },
      {
        accessorKey: "description",
        header: "Description",
        size: 150,
      },
    ],
    [],
  );

  const fetchData = async (payload) => {
    const sortField = sorting.length > 0 ? sorting[0].id : undefined;
    const sortOrder = sorting.length > 0 ? (sorting[0].desc ? "desc" : "asc") : undefined;
    
    const queryPayload = {
      pagination: true,
      limit: pageSize,
      offset: page * pageSize,
      ...(sortField && { sortBy: sortField }),
      ...(sortOrder && { sortOrder: sortOrder }),
      ...payload,
    };
    
    const res = await dispatch(getAllServices(queryPayload));
    if (res?.payload) {
      const p = res.payload;
      setData(p.servicesData || p.services || p.data || p.result || []);
      setCount(p.count !== undefined ? p.count : (p.total !== undefined ? p.total : 0));
    }
  };

  useEffect(() => {
    fetchData({ search: debouncedSearch, filters: columnFilterSearch });
  }, [dispatch, page, pageSize, debouncedSearch, columnFilterSearch, sorting]);

  const getServices = () => {
    fetchData({ search: debouncedSearch, filters: columnFilterSearch });
  };

  const handlePageChange = (event) => {
    const newState = typeof event === "function" ? event({ pageIndex: page, pageSize: pageSize }) : event;
    setPage(newState.pageIndex);
    setPageSize(newState.pageSize);
  };

  const handleOnChangeSearch = (value) => {
    setSearchQuery(value);
    setPage(0);
  };

  const rowAction = (event, row) => {
    dispatch(setService(row.original));
    history(`/pages/service-details`);
    console.log(event, row);
  };

  const table = useMaterialReactTable({
    columns,
    data,
    muiTableBodyRowProps: ({ row }) => ({
      onClick: (event) => rowAction(event, row),
      sx: {
        cursor: "pointer",
      },
    }),
    initialState: { density: "compact" },
    globalFilter: searchQuery,
    onGlobalFilterChange: handleOnChangeSearch,
    manualPagination: true,
    manualSorting: true,
    manualFiltering: true,
    rowCount: totalCount || 0,
    onPaginationChange: handlePageChange,
    onSortingChange: setSorting,
    onColumnFiltersChange: setColumnFilters,
    state: {
      pagination: { pageIndex: page, pageSize: pageSize },
      sorting,
      columnFilters,
      globalFilter: searchQuery,
    },
    renderTopToolbarCustomActions: ({ table }) => (
      <div className="d-flex">
        <div
          sx={{
            display: "flex",
            gap: "16px",
            padding: "8px",
            flexWrap: "wrap",
          }}
        >
          <button
            className="btn bg-primary"
            disabled={client === "ts"}
            onClick={() => setModalOpen(true)}
          >
            Create Service Grouping
          </button>
        </div>
      </div>
    ),
  });

  const toggle = useCallback(() => {
    console.log("modal close");
    setModalOpen(!isModalOpen);
  }, [isModalOpen]);

  const toggleSubService = useCallback(() => {
    setSubServiceModalOpen(!isSubServiceModalOpen);
  }, [isSubServiceModalOpen]);

  const toggleCreateForm = useCallback(() => {
    console.log("cancel form");
    setCreateFormModalModalOpen(!isCreateFormModalOpen);
  }, [isCreateFormModalOpen]);

  return (
    <Fragment>
      <CreateServiceModal
        isOpen={isModalOpen}
        toggle={toggle}
        pagination={{ pageIndex: page, pageSize: pageSize }}
      ></CreateServiceModal>
      <CreateSubServiceModal
        isOpen={isSubServiceModalOpen}
        toggle={toggleSubService}
        pagination={{ pageIndex: page, pageSize: pageSize }}
      ></CreateSubServiceModal>
      <CreateFormModal
        isOpen={isCreateFormModalOpen}
        toggle={toggleCreateForm}
      ></CreateFormModal>
      <Breadcrumbs mainTitle="Service Grouping" parent="Services" parentPath="service-grouping" title="Services List" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <MaterialReactTable table={table} />
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default ServicesTable;
